import { loadOptions } from '../../versa/formset.js';

export default function (...args)
{
	return {
		options: [
			{ value: 'P', label: 'Impressora' },
		],
		captureEvents(_this = this)
		{
			loadOptions(this.selector, this.options);
			this.safeProtoCall(_this);
		}
	};
}

